import * as React from "react";

interface IProps {
  count: string;
}

const curve = 2;

const renderWholeBooks = (books: number) => {
  const toRender = [];
  for (let i = 0; i < books; i++) {
    toRender.push(
      <rect
        key={i}
        x={8 * i + 5}
        y={5}
        height={35}
        width={5}
        rx={curve}
        ry={curve}
        stroke="white"
        fill="white"
      />
    );
  }
  return toRender;
};

const renderPartialBooks = (books: number, offset: number) => {
  const toRender = [];
  for (let i = 0; i < books; i++) {
    toRender.push(
        <rect
          key={i}
          x={offset * 8 + 8 * i + 1}
          y={14}
          height={25}
          width={5}
          rx={curve}
          ry={curve}
          stroke="#99B8D2"
          fill="#99B8D2"
          transform="skewX(10)"
        />
    );
  }
  return toRender;
};

/**
 * The number of whole books to show
 * @param input number
 */
const getWhole = (input: number) => Math.floor(input);

/**
 * The number of partial books to show
 * @param input number
 */
const getPartial = (input: number) =>
  (Math.round((input % 1) * 100) / 100) * 10;

/**
 * An object containing both of the book numbers to show
 * @param input number
 */
const getParts = (input: number) => ({
  partial: getPartial(input),
  whole: getWhole(input)
});

const BookVisualisation = (props: IProps) => {
  const books = getParts(parseFloat(props.count));

  return (
    <svg height={40}>
      <text x={0} y={32} stroke="white" fill="white" fontSize={28}>{props.count}</text>
      <g transform="translate(40, 0)">
        {renderWholeBooks(books.whole)}
        {renderPartialBooks(books.partial, books.whole)}
      </g>
    </svg>
  );
};

export default BookVisualisation;



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/Libraries/BookVisualisation.tsx